import {breakpoints} from '@/Themes/Mistubishi/breakpoints.js';
import {components} from '@/Themes/Mistubishi/components.js';
import {palette} from '@/Themes/Mistubishi/palette.js';
import {typography} from '@/Themes/Mistubishi/typography.js';
import {createTheme} from '@mui/material';
import {frFR} from '@mui/material/locale';

export const theme = createTheme(
    {
        breakpoints: {...breakpoints},
        palette: {...palette},
        typography: {
            ...typography,
            h1: {
                ...typography.h1,
                '&::after': {
                    ...typography.h1['&::after'],
                    color: palette.primary.main,
                },
            },
        },
        components: {...components},
        shape: {
            borderRadius: 8,
        },
        spacing: (factor) => `${0.5 * factor}rem`,
    },
    frFR,
);
export const theme_air_water = createTheme(
    {
        ...theme,
        palette: {
            ...theme.palette,
            mitsubishi: palette.primary,
            primary: palette.air_water,
        },
        typography: {
            ...typography,
            h1: {
                ...typography.h1,
                '&::after': {
                    ...typography.h1['&::after'],
                    color: palette.air_water.main,
                },
            },
        },
    },
    frFR,
);
export const theme_air_air = createTheme(
    {
        ...theme,
        palette: {
            ...theme.palette,
            mitsubishi: palette.primary,
            primary: palette.air_air,
        },
        typography: {
            ...typography,
            h1: {
                ...typography.h1,
                '&::after': {
                    ...typography.h1['&::after'],
                    color: palette.air_air.main,
                },
            },
        },
    },
    frFR,
);
